export default {
  type: "users",
  first_name: null,
  last_name: null,
  email: null,
  is_admin: false,
  password: null,
  password_confirmation: null,
  restricted_to_clients: false,
  relationshipNames: ["allowedClients"],
  allowedClients: [],
};
